<template>
  <q-dialog
    v-model="showDialog"
    persistent
  >
    <q-card
      style="width: 50%; max-width: 350px;"
    >
      <q-card-section
        class="row items-center q-ma-sm"
      >
        <div class="text-h6">
          Find Existing Member
        </div>
        <q-space />
        <q-btn
          icon="close"
          flat
          round
          dense
          @click="closeWithoutAssigningUser"
        />
      </q-card-section>
      <q-card-section>
        <div
          class="row q-col-gutter-md"
        >
          <q-select
            v-model="selectedUser"
            :display-value="selectedUser && selectedUser.name"
            label="Find existing member..."
            outlined
            :use-input="true"
            class="q-mr-md full-width"
            debounce="300"
            :options="users.data"
            input-style="search"
            autofocus
            clearable
            @filter="filterUsers"
            @update:model-value="user => selectUser(user)"
          >
            <template #no-option>
              <q-item>
                <q-item-section class="text-grey">
                  No results
                </q-item-section>
              </q-item>
            </template>
            <template #option="scope">
              <q-item
                v-bind="scope.itemProps"
                v-on="scope.itemEvents"
              >
                <q-item-section avatar>
                  <q-img
                    no-spinner
                    no-transition
                    width="30px"
                    :src="scope.opt.photoSmallUrl"
                  />
                </q-item-section>
                <q-item-section>
                  {{ scope.opt.name }}
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
      </q-card-section>
      <q-card-section>
        <div class="row">
          <q-btn
            size="xl"
            class="col"
            color="primary"
            label="Assign to user"
            :disable="!selectedUser"
            @click="assignUser"
          />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'SelectUserForm',
  inject: ['order'],
  emits: ['close-without-assigning-user'],
  data () {
    return {
      orderItem: null,
      selectedUser: null,
      showDialog: false,
      userSearchString: ''
    }
  },
  models: {
    users: {
      fields: 'search',
      variables () {
        return {
          searchString: this.userSearchString,
          orderBy: 'selectedAt',
          descending: true,
          limit: 30
        }
      }
    }
  },
  methods: {
    filterUsers (val, update, abort) {
      update(() => {
        this.userSearchString = val
      })
    },
    selectUser (user) {
      this.selectedUser = user
      this.userSearchString = ''
    },
    show (orderItem) {
      this.orderItem = orderItem
      this.selectedUser = orderItem.voucherPurchase?.user || this.order.user || null
      this.showDialog = true
    },
    closeWithoutAssigningUser () {
      this.$emit('close-without-assigning-user', this.orderItem)
      this.resetState()
    },
    assignUser () {
      if (this.orderItem.type === 'voucher-purchase' || this.orderItem.type === 'voucher-service-issue') {
        this.orderItem.voucherPurchase.setRelated('user', this.selectedUser)
      } else if (this.orderItem.type === 'voucher-package-purchase') {
        this.orderItem.issuedVoucherPackage.setUser(this.selectedUser)
      }

      this.resetState()
    },
    resetState () {
      this.orderItem = null
      this.selectedUser = null
      this.showDialog = false
      this.userSearchString = ''
    }
  }
}
</script>
